import React from 'react';
import { css } from '@emotion/react';
import { IconCircleXFill } from '../icons/generated';
import { semantic_colors } from '../../foundation';
import { Stack } from '../stack';
import { RemoveButton } from '../date-picker/DatePickerIcon';
import { IconClock } from '../icons/generated';

export interface TimePickerIconProps {
  showRemoveIcon?: boolean;
  onClick?: () => void;
}

// TODO(@olive-sally): DatePickerIcon 통합
export const TimePickerIcon = ({ showRemoveIcon, onClick }: TimePickerIconProps) => {
  return (
    <Stack direction='row' align='center'>
      {showRemoveIcon ? (
        <RemoveButton
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          css={css`
            border: 0;
            width: auto;
            height: auto;
          `}
        >
          <IconCircleXFill size={16} color={semantic_colors.content.tertiary} />
        </RemoveButton>
      ) : (
        <IconClock size={16} color={semantic_colors.content.tertiary} />
      )}
    </Stack>
  );
};
